<div [class.hidden]="!opened" class="drawer-root">
  <div (click)="close()" [@fadeInOut]="animationState" (@fadeInOut.done)="onAnimationDone()" class="drawer-bg"></div>
  <div
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    class="drawer"
    [@slideInOut]="animationState"
    [ngStyle]="{'max-width': drawerWidth}"
    (scroll)="onScroll()"
    #drawerContent
  >
    @if (!notificationDrawer) {
      <mc-drawer-toastr></mc-drawer-toastr>
    }

    <div class="drawer-header">
      <div class="drawer-header__left">
        <ng-container [ngTemplateOutlet]="headerTemplateRef"></ng-container>
      </div>

      <button
        aria-label="Close drawer"
        #closeButton
        (click)="close()"
        class="close-btn"
        data-testid="drawer.close-button"
      >
        <mat-icon aria-hidden="false" title="Close icon" svgIcon="cross_fill"></mat-icon>
      </button>
    </div>

    <ng-content></ng-content>
  </div>
</div>
